export const reportListResponse = {
  id: { key: "reportId" },
};
